export default __webpack_public_path__ + "5d094fb45e41f74b2a0d1286459f509f.png";